<template>
  <div
    class="ui-avatar"
    :class="classes"
    :style="{ width: `${size}px`, height: `${size}px` }"
  >
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'UiAvatar',

  props: {
    size: {
      type: [Number, String],
      default: 96
    },
    shape: {
      type: String,
      default: 'circle'
    }
  },

  computed: {
    classes() {
      return [
        `ui-avatar--${this.shape}`
      ];
    }
  }
}
</script>

<style>
  .ui-avatar {
    align-items: center;
    display: inline-flex;
    justify-content: center;
    line-height: normal;
    position: relative;
    text-align: center;
    vertical-align: middle;
    overflow: hidden;
  }
  .ui-avatar--circle {
    border-radius: 50%;
  }
  .ui-avatar--square {
    border-radius: 10px;
  }
  .ui-avatar img {
    border-radius: inherit;
    display: inline-flex;
    height: inherit;
    width: inherit;
    object-fit: cover;
  }
</style>
